import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Landing from '@/views/Landing.vue';
import RegisterSchool from '@/views/RegisterSchool.vue';
import RegisterSchoolFree from '@/views/RegisterSchoolFree.vue';
import VerificationSchool from '@/views/VerificationSchool.vue';
import RegisterJobFair from '@/views/RegisterJobFair.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'landing',
    component: Landing,
  },
  {
    path: '/join/:code',
    name: 'register-school',
    component: RegisterSchool,
  },
  {
    path: '/join',
    name: 'register-school',
    component: RegisterSchoolFree,
  },
  {
    path: '/verify',
    name: 'verification-school',
    component: VerificationSchool,
  },
  {
    path: '/jobfair',
    name: 'register-jobfair',
    component: RegisterJobFair,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => {
    return {
      x: 0,
      y: 0,
    };
  },
  routes,
});

export default router;
